module.exports =
{
    theme: 'light', // 'dark', 'light'
    // Meta Tags für Facebook, Twitter
    meta: {
        // Seiten Title
        title: 'Wie Cannabis im Körper wirkt',
        // Beschreibung
        description: 'Entdecken Sie interaktiv, was alles in der Cannabispflanze steckt. Bisher war der Besitz verboten. Jetzt ist Kiffen für Erwachsene erlaubt.',
        // Bild
        image: 'https://3d.zdf.de/cannabis-wirkung-thc-cbd/img/Story-Link-Preview.jpg',
        // URL
        url: 'https://3d.zdf.de/cannabis-wirkung-thc-cbd/',
    },
    tracking: {
        storyName: 'Cannabis',
        storyID: 'cannabis',
        // Tracking deaktivieren
        //disabled: true,
    },
    babylon: {
        lightIntensity : 1,

        camera: {
            // Position, Ausrichtung und Kamera Bewegung
            // Kamera Position
            position: [.5 * Math.PI, .5 * Math.PI, 10], // alpha, beta, radius
            moveFunction: 'move', // Wie die Kamera bewegt wird: 'move' Kamerafahrt, 'set' Springt zur Position
            target: [0, 0, 0], // Wohin die Kamera blickt
            animationSpeed: 280, // Geschwindigkeit der Kamerabewegung

            // Begrenzungen
            alphaLimits: [null, null],
            betaLimits: [0, Math.PI / 2],
            radiusLimits: [5, 100], // minCamRadius, maxCamRadius
            clipping: [0.75, 10000.0],
            fov: 0.8,

            // Automatisches Drehen
            useAutoRotationBehavior: false,
            idleRotationSpeed: 0.05,

            // Steuerung
            panSensibility: 0, // 0 is deactivated
            wheelPrecision: 25.0, // 3.0 ist Standard
        },
    },
    audio: {
        enabled: true
    },
    objects:
    [
        /* {
            // Name des Objekts zur Ansteuerung
            name: "zdfLogo",
            // GLB Dateiname im Ordner app/public/3d-models
            filename: "ZDF_Logo.glb",
            options: {
                //// BaseObject
                // true: Objekt anzeigen
                visible: true,
                // Skalierung: Objekt Größe ändern in allen Dimensionen
                scaling: [1, 1, -1],
                // Skalierung: Objekt Größe ändern (Alle Dimensionen gleich)
                //scale: 0.01,
                // Position
                position: [0, 0, 0],
                // Rotation
                rotation: [0.5 * Math.PI, 0, 0],
                // Rotation Quaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
                //rotationQuaternion: [0.707, 0, 0, 0.707],
                // Transparenz (0 bis 1)
                //visibility: 0.25,
                // RGB-Farbe (diffuse) jeweils Werte 0 bis 255
                //diffuse: [255, 0, 0],
                // Zur Kamera ausrichten
                // 1: X-Achse, 2: Y-Achse, 4: Z-Achse, 7: Alle Achsen
                // 3: X & Y-Achse, 5: Z & X-Achse, 6: Z & Y-Achse
                // https://doc.babylonjs.com/typedoc/classes/babylon.abstractmesh#billboardmode
                billboardMode: 0,
                // Overlay Color zum hervorheben von Objekten
                //overlayColor: [250/255, 125/255, 25/255],
                // Rendering Group ID legt Objekte eine ebene nach vorne (Auch beim Hotspot)
                //renderingGroupId: 1

                //// MeshObject
                // Objekt mit Fade ein und ausblenden, wenn visible sich ändert
                fade: false,
                // Unter-Mesh-Objekte in der Datei
                // Name des Meshs wie im 3D Model
                ZDF_Logo: {
                    visible: true,
                    // Ist das Objekt anklickbar?
                    // Bei true wird ein Hotspot durch das Objekt nicht anklickbar, wenn verdeckt.
                    // Darum sollte bei transparenten Objekten ggf. pickable: false gesetzt werden.
                    pickable: true,

                    ZDF_Logo_2: {
                        visible: true,
                    }
                },

                //// BabylonObject
                // animation=true: startet die Animation im Objekt
                animation: false,

                // Nur initial, nicht per babylonState
                // OnClick Trigger
                // trigger: function () { }
            },
            // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
            callback: function (zdfLogo) // eslint-disable-line no-unused-vars
            {

            }
        },*/

        // Glasmann
        {
            name: "glasmann",
            filename: "glasmann_011_aw.glb",
            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [-.1, .1, .1],
                rotation: [0, Math.PI, 0],

                geo_brain: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },
                
                geo_glasmann: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },
            
                geo_system_gruen: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_schlecht_label: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_schlecht_text: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_gut_label: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_gut_text: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_anandamid: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_joint: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_label_cbrezeptor: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_text_cbrezeptor: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_label_endocannabinoide: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_text_endocannabinoide: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_label_thc: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_text_thc: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },
            },
        }, 

        // Cannabis
        {
            name: "cannabis",
            filename: "cannabis_008_aw.glb",
            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [3, 3, 3],
                rotation: [0, 0, 0],

                geo_cannabis: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_topf: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },
            
                geo_thc_label: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                    renderingGroupId: 2,
                },

                geo_thc_schrift: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                    renderingGroupId: 2,
                },
            
                geo_cbd_label: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                    renderingGroupId: 2,
                },

                geo_cbd_schrift: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                    renderingGroupId: 2,
                },

                geo_label_bluete: {
                    visible: false,
                    position: [0.1, 0.08, 0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_label_fasern: {
                    visible: false,
                    position: [0.1, -0.125, -0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_label_harz: {
                    visible: false,
                    position: [0.1, 0.11, 0.14],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_label_samen: {
                    visible: false,
                    position: [0.1, -0.13, -0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_text_bluete: {
                    visible: false,
                    position: [0.1, 0.08, 0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_text_fasern: {
                    visible: false,
                    position: [0.1, -0.125, -0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_text_harz: {
                    visible: false,
                    position: [0.1, 0.11, 0.14],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
                geo_text_samen: {
                    visible: false,
                    position: [0.1, -0.13, -0.1],
                    scaling: [-1, 1, 1],
                    rotation: [0, 1.5708, 0],
                },
            
            },
        },

        // Gluehende Spitze des Joints
        // {
        //     name: "joint_gluehend",
        //     filename: "glasmann_joint_gluehend_011_aw.glb",
        //     options: {
        //         visible: true,
        //         position: [0, 0.1, 0],
        //         scaling: [3, 3, 3],
        //         rotation: [0, 0, 0],

        //         geo_gluehend: {
        //             visible: true,
        //             position: [0, 0, 0],
        //             scaling: [1, 1, 1],
        //             rotation: [0, 0, 0],
        //         },
        //     },
        // },

        // Cannabisbluete
        {
            name: "cannabis_bluete",
            filename: "cannabisbluete_006_aw.glb",
            options: {
                visible: false,
                position: [0, 0, 0],
                scaling: [3, 3, 3],
                rotation: [0, 0, 0],
            },
        },

        // Vergleich Sativa vs Indica
        {
            name: "vergleich",
            filename: "vergleich_002_aw.glb",
            options: {
                visible: false,
                position: [0, 2, 0],
                scaling: [20, 20, 20],
                rotation: [0, -Math.PI, Math.PI/2],

                geo_indica: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_sativa: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },

                geo_trennlinie: {
                    visible: false,
                    position: [0, 0, 0],
                    scaling: [1, 1, 1],
                    rotation: [0, 0, 0],
                },
            },
        },

    ]
};
